import type { FC, ReactElement } from 'react';
import { useMemo } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import type { BlockingModalActionButton } from './BlockingModalContent';
import { BlockingModalContent } from './BlockingModalContent';

export const PrivateTableDuplicatePlayerConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToCasinoLobby = useRedirectToLobbyCallbackConnected();

  const action: BlockingModalActionButton[] = [
    {
      tk: 'CLOSE',
      type: ButtonVariant.MAIN,
      click: (): void => {
        redirectToCasinoLobby();
      },
    },
    {
      tk: 'LOBBY_TAKE_A_SEAT',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        dispatch(popupActions.dismissPopup(PopupType.DuplicatePrivatePlayerSession));
      },
    },
  ];

  const messageContent = useMemo(() => {
    return <L10nText tk="POPUP_TAKE_A_SEAT_2" markdown />;
  }, []);

  return <BlockingModalContent titleTk="PRIVE_MULTIPLE_SESSIONS" messageComponent={messageContent} actions={action} />;
};
